import React, { useEffect, useState, useCallback } from 'react'
import { Box, Typography, Divider, Paper, Grid, SpeedDial, Card, CardContent, CardActions, IconButton,
  Avatar, List, ListItem, ListItemIcon, ListItemText, Button, Container
} from '@mui/material';
import Modal from 'components/Modal';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import { useSnackbar } from 'notistack';
import AddPass from './Add';
import useConfirm from 'core/hooks/useConfirm';
import { getPasses, getPassDetails, deletePass } from 'services/passes';
import { useTheme } from '@mui/material/styles';

const Passes = () => {

  const [openModal, setOpenModal] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [passess, setPassess] = useState([]);
  const [passDetails, setPassDetails] = useState(null);
  const confirm = useConfirm();
  const theme = useTheme();

  useEffect(() => {
    getAllPasses();
  }, []);

  const onModalClose = useCallback(
    () => {
      setOpenModal(false);
    },
    [setOpenModal],
  )

  function getAllPasses() {
    getPasses().then(({response, error}) => {
      if(response){
        setPassess([...response]);
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  const onPassAdded = useCallback(
    () => {
      getAllPasses();
      setOpenModal(false);
      setPassDetails(null)
    },[]);

  const onPassDelete = (e,id) => {
    e.stopPropagation();
    setPassDetails(null);
    if(id) {
      confirm({ title: 'Delete Pass?', description: 'Are you sure you want to delete this pass?' })
    .then(() => { 
      deletePassData(id);
    })
    }
  };

  const deletePassData = (id) => {
    deletePass({id}).then(({response, error}) => {
      if(response){
        enqueueSnackbar((response?.message || "Pass deleted successfully"), {variant: 'success'});
        getAllPasses();
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  const onAddPassBtnClick = (e) => {
    setPassDetails(null)
    setOpenModal(true);
  };

  const onCardClick = (e,id) => {
    e.preventDefault();
    getPassDetails({id}).then(({response, error}) => {
      if(response){
        setPassDetails({...response})
        setOpenModal(true);
      } else {
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }

  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }}>
      <Typography component="h2" variant="h6" color="secondary" gutterBottom sx={{mb: 1}}>
        Passes
      </Typography>
      <Divider />
      <Box noValidate  sx={{ mt: 2 }} >
        <Grid container columnSpacing={4} rowSpacing={2} >
          {passess.map((pass, index) => (
            <Grid item xs={10} sm={6} md={6} xl={3} lg={4} key={index} >
              <Card sx={{ p: 1.5, pb: '3rem', position: 'relative', cursor: 'pointer', height: '100%', border: `1px solid${theme.palette.primary.light}`}} onClick={(e) => onCardClick(e, pass?.id)}>
                <CardContent>
                  <Typography gutterBottom variant="body1" component="div" textAlign="center" sx={{ p: 0, m:0, lineHeight: 1, }}>
                    {pass.title}
                    <Typography gutterBottom variant="caption" component="div" textAlign="center" sx={{ p: 1, lineHeight: 1, }}>
                      {pass.property.name}
                    </Typography>
                    <Avatar sx={{ width: 56, height: 56, margin: '1em  auto .7em',  bgcolor: theme.palette.primary.dark}}>
                      <CardMembershipIcon />
                    </Avatar>
                  </Typography>
                 
                  
                  <Typography gutterBottom variant="subtitle2" component="div" textAlign="center">
                    Rs. {pass.price} /-
                  </Typography>

                  <Box>
                    <List dense={true}>
                      {Array.isArray(pass?.features) ? 
                      pass?.features.map((feature, index) => (
                        <ListItem key={index} sx={{ p: 0,}}>
                          <ListItemIcon>
                            <CheckIcon />
                          </ListItemIcon>
                          <ListItemText primary={feature} />
                        </ListItem>
                      )) : null}
                    </List>
                  </Box>
                </CardContent>
                <CardActions  sx={{ position: 'absolute', top: 0, right: 0}}>
                  <IconButton variant="raised"  onClick={(e) => onPassDelete(e, pass?.id)}
                  >
                    <DeleteForeverIcon sx={{color: '#9d3939'}} />
                  </IconButton>
                </CardActions>
                <Container sx={{textAlign: 'center', position: 'absolute', bottom: '1rem'}}>
                  <Button variant="contained" onClick={(e) => {
                    e.stopPropagation();
                    alert('get payment gateway')
                  }}>Buy</Button>
                </Container>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <SpeedDial
        onClick={onAddPassBtnClick}
        ariaLabel="Add Pass"
        sx={{ position: 'absolute', bottom: 75, right: 75 }}
        icon={<AddIcon />}
      />
      <Modal
        maxWidth={"sm"}
        open={openModal} 
        onModalClose={onModalClose}
        title="Plan Details"
        // title={passDetails ? 'Update Pass' : 'Add Pass'}
      >
        <AddPass onPassAdded={onPassAdded} passDetails={passDetails} />
      </Modal>
    </Paper>
  );
}
 
export default React.memo(Passes);
